import { Anchor, Stack } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import type { FC } from 'react';
import { Link } from 'react-router';

import { PasswordInput } from '../../../components/reactHookFormMantine/PasswordInput.tsx';
import { TextInput } from '../../../components/reactHookFormMantine/TextInput.tsx';
import { useI18n } from '../../../hooks/useI18n.ts';
import type { FormInputsContent } from '../../FormInputsContent.ts';
import type { FormLogin } from './schema.ts';

export const Login: FC<FormInputsContent<FormLogin>> = ({ useFormValue: { control }, forgotPasswordText }) => {
  const { t } = useI18n();

  const [passwordVisible, { toggle }] = useDisclosure(false);

  return (
    <Stack gap="xxxs">
      <Stack gap="xxs">
        <TextInput
          control={control}
          label={t('signup_label--email-address') ?? 'Email address'}
          name="email"
          placeholder={t('signup_placeholder--email-address') ?? 'example@emailaddress.com'}
          type="email"
        />
        <PasswordInput
          control={control}
          label={t('signup_label--password') ?? 'Password'}
          name="password"
          placeholder={t('signup_placeholder--password') ?? 'Password'}
          visible={passwordVisible}
          onVisibilityChange={toggle}
        />
      </Stack>
      <Anchor component={Link} size="xs" ta="right" to="/auth/reset-password/enter-email">
        {forgotPasswordText}
      </Anchor>
    </Stack>
  );
};
